import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import * as jobActions from '../jobActions';import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import jobPaymentFactory from '../models/jobPaymentModel';
import globalRelay from '../globalRelay';
import util from '../util';
import { Confirm, CurrencyInput, Expander, Popup } from './sharedComponents';
import { getCollection, ModelCollection } from 'Scripts/store';

const ContextMenu = ({ duplicateAction, deleteAction, isValid }) => {
	const onDuplicateClicked = (e) => {
		e.preventDefault();
		if (!isValid) { return; }
		duplicateAction();
	};
	const onDeleteClicked = (e) => {
		e.preventDefault();
		deleteAction();
	};

	return	(<div className="content scrollable">
		<ul className="menu">
			<li className={ !isValid ? 'disabled' : ''}><a className="button icon iconLabel duplicateItem" onClick={ onDuplicateClicked }><span>Duplicate</span></a></li>
			<li><a className="button icon iconLabel removeItem delete" onClick={ onDeleteClicked }><span>Delete</span></a></li>
		</ul>
	</div>);
};

class PaymentRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { shouldValidate: this.props.alwaysValidate };

		this.handleButtonClick = this.handleButtonClick.bind(this);
	}

	validate (property?) {
		if (!property || this.state.shouldValidate) {
			const result = !this.props.payment.test(property);

			return result;
		}
		return true;
	}

	handleButtonClick (e) {
		e.preventDefault();

		const valid = this.validate();

		if (!valid) {
			this.setState({ shouldValidate: true });
		}
		else {
			// this assumes that the add handler succeeds
			this.setState({ shouldValidate: this.props.alwaysValidate });
		}

		this.props.buttonHandler(valid, e);
	}

	updateModel (path, autoSave, e) {
		const newVal = autoSave ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel(payment => {
			// prevent system generated and applied payments from being substantially altered
			if ((payment.systemGenerated || payment.appliedToContract) && ['amount', 'type'].indexOf(path) !== -1) {
				return;
			}

			payment.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	render () {
		const { buttonClasses, classNames, payment } = this.props;

		return (<tr className={ classNames.join(' ')}>
			<td />
			<td className="jobNumber"><span className="readOnly">{ (payment && payment.relayNumber) || '-' }</span></td>
			<td className={(!this.validate('type') ? 'required' : '')}>
				<select value={ payment.viewValue('type') } onChange={this.updateModel.bind(this, 'type', true)}>
					<option value="">Select</option>
					<option value="deposit">Deposit</option>
					<option value="design-retainer">Design Retainer</option>
					<option value="other">Other</option>
					<option value="pre-deposit">Pre-Deposit</option>
				</select>
			</td>
			<td className={(!this.validate('transactionMethod') ? 'required' : '')}>
				<select value={ payment.viewValue('transactionMethod') } onChange={this.updateModel.bind(this, 'transactionMethod', true)}>
					<option value="">Select</option>
					<option value="cheque">{ globalRelay.config!.getString('Cheque') }</option>
					<option value="credit-card">Credit Card</option>
					<option value="purchase-order">Purchase Order</option>
					<option value="cash">Cash</option>
					<option value="account">Account</option>
				</select>
			</td>
			<td className={(!this.validate('transactionReference') ? 'required' : '')}><input type="text" placeholder="Enter a Transaction Reference" autoCapitalize="" autoCorrect="off" value={ payment.viewValue('transactionReference') } onChange={ this.updateModel.bind(this, 'transactionReference', false) } onBlur={ this.updateModel.bind(this, 'transactionReference', true) } /></td>
			<td className={(!this.validate('description') ? 'required' : '')}><input type="text" placeholder="Enter a Description" autoCapitalize="" autoCorrect="off" value={ payment.viewValue('description') } onChange={ this.updateModel.bind(this, 'description', false) } onBlur={ this.updateModel.bind(this, 'description', true) } /></td>
			<td className={(!this.validate('amount') ? 'price required' : 'price')}><CurrencyInput placeholder="0.00" value={ payment.viewValue('amount') } onChange={ this.updateModel.bind(this, 'amount', false) } onBlur={ this.updateModel.bind(this, 'amount', true) } /></td>
			<td><button className={buttonClasses.join(' ')} onClick={ this.handleButtonClick }><span /></button></td>
			<td />
		</tr>);
	}
}

class PaymentTable extends React.Component<any,any> {
	private _pendingPayment;

	constructor (props) {
		super(props);

		this._pendingPayment = this.createPendingPayment(props);
	}

	addPaymentHandler (paymentKey, isValid) {
		if (!isValid) { return; }

		this.props.updateModel(job => {
			if (paymentKey === this._pendingPayment.key) {
				job.payments.add(this._pendingPayment);

				this._pendingPayment = this.createPendingPayment(this.props as any);
			}
		}, { autoSave: true });
	}

	createPendingPayment ({ jobCostKey, changeOrderKey }) {
		return jobPaymentFactory({ jobCostKey: jobCostKey, changeOrderKey: changeOrderKey });
	}

	contextMenuHandler (paymentKey, isValid, e) {
		const popup = <Popup target={e.target}><ContextMenu duplicateAction={this.duplicatePayment.bind(this, paymentKey)} deleteAction={this.deletePayment.bind(this, paymentKey)} isValid={ isValid } /></Popup>;
		actions.pushModal({ component: popup });
	}

	deletePayment (paymentKey) {
		actions.popModal();

		const deleter = () => {
			actions.popModal();

			this.props.updateModel(job => {
				job.payments.delete(paymentKey);
			}, { autoSave: true });
		};

		actions.pushModal({
			component: <Confirm title="Delete Payment?" message="Are you sure you want to remove this payment?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ deleter } />
		});
	}

	duplicatePayment (paymentKey) {
		actions.popModal();
		this.props.updateModel(job => {
			const payment = job.payments.get(paymentKey);

			if (payment) {
				job.payments.add(jobPaymentFactory(_.omit(payment.toDocument(), 'key', 'relayId')));
			}
		}, { autoSave: true });
	}

	updateModel (key, updater, options) {
		const pendingPayment = this._pendingPayment;

		this.props.updateModel(job => {
			let payment = job.payments.get(key);

			if (!payment && key === pendingPayment.key) {
				payment = pendingPayment;
				options.autoSave = false;
			}

			if (payment) {
				updater(payment);
			}
		}, options);
	}

	render () {
		const { payments } = this.props;
		const pendingPayment = this._pendingPayment;

		let subtotal = 0;
		const rows = _.map(payments, payment => {
			subtotal += (payment.amount || 0);
			return <PaymentRow key={ payment.key } payment={payment} classNames={['added']} updateModel={ this.updateModel.bind(this, payment.key) } buttonHandler={ this.contextMenuHandler.bind(this, payment.key) } buttonClasses={['icon', 'iconOnly', 'contextMenu']} alwaysValidate={ true } />;
		});

		rows.unshift(<PaymentRow key={ pendingPayment.key } payment={pendingPayment} classNames={[]} updateModel={ this.updateModel.bind(this, pendingPayment.key) } buttonHandler={ this.addPaymentHandler.bind(this, pendingPayment.key) } buttonClasses={['icon', 'iconOnly', 'addItem']}/>);

		return (<table className="compact" cellPadding="0" cellSpacing="0">
			<thead>
				<tr>
					<td />
					<td className="jobNumber"><span className="readOnly">Relay No.</span></td>
					<td><span className="readOnly">Type</span></td>
					<td><span className="readOnly">Payment Method</span></td>
					<td><span className="readOnly">Transaction Reference</span></td>
					<td><span className="readOnly">Description</span></td>
					<td className="price"><span className="readOnly">Amount</span></td>
					<td />
					<td />
				</tr>
			</thead>
			<tbody>
				{ rows }
			</tbody>
			<tfoot className="subtotal">
				<tr>
					<td />
					<td />
					<td className="right" colSpan={4}>Total</td>
					<td className="cost" colSpan={1}><span className="readOnly">{ util.formatAsCurrency(subtotal) }</span></td>
					<td />
					<td />
				</tr>
			</tfoot>
		</table>);
	}
}

const PaymentGroup = ({ label, payments, contract, updateModel }: any) => {
	const sections:JSX.Element[] = [];
	let sectionPayments;

	if (contract) {
		sectionPayments = _.filter(payments, p => p.jobCostKey === contract.key);
		sections.push(<section key={ contract.key }><div className="inner"><PaymentTable payments={ sectionPayments } updateModel={ updateModel } jobCostKey={ contract.key } /></div></section>);

		_.forEach(contract.changeOrders, changeOrder => {
			if (changeOrder.isContract) {
				sectionPayments = _.filter(payments, p => p.changeOrderKey === changeOrder.key);
				sections.push(<section key={ changeOrder.key }>
					<header>
						<span>Change No. { changeOrder.relayId } - { changeOrder.name }</span>
					</header>
					<div className="inner">
						<PaymentTable payments={ sectionPayments } updateModel={ updateModel } changeOrderKey={ changeOrder.key } />
					</div>
				</section>);
			}
		});
	}
	else {
		sectionPayments = _.filter(payments, p => !p.jobCostKey && !p.changeOrderKey);
		sections.push(<section key="main"><div className="inner"><PaymentTable payments={ sectionPayments } updateModel={ updateModel } /></div></section>);
	}

	return (<Expander title={ label } key={ label }>{ sections }</Expander>);
};

export default class JobPayments extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(this.props);
	}

	UNSAFE_componentWillReceiveProps (nextProps) {
		this.setState(this.getStateFromProps(nextProps));
	}

	getStateFromProps (props) {
		const { store } = componentServices;
		const job = props.job;
		const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts});
		const state = _.assign({}, this.state);

		if (job) {
			if (state.fetchedJobKey !== job.key) {
				// this will also fill job costs for the job
				jobActions.fetchJob({ key: job.key });
				state.fetchedJobKey = job.key;
			}

			if (state.jobCosts !== jobCosts) {
				state.jobCosts = jobCosts;

				const items:any[] = [];
				let firstJobContract;

				jobCosts.filter(jc => jc.jobKey === job.key && jc.type === 'contract').forEach(jc => {
					const approvedStatus = jc.getMostRecentStatusByStatus('approved');

					if (!firstJobContract || (approvedStatus && (!firstJobContract.statusDate || approvedStatus.dateCreated < firstJobContract.statusDate))) {
						firstJobContract = { key: jc.key, statusDate: (approvedStatus && approvedStatus.dateCreated) };
					}

					items.push({
						label: `Addition - ${jc.name}`,
						relayId: jc.relayId,
						contract: jc
					});
				});

				const originalContractItem = (firstJobContract && _.find(items, { contract: firstJobContract })) || _.first(_.sortBy(items, ['relayId']));
				if (originalContractItem) {
					originalContractItem.label = 'Original Job';
				}

				state.items = items;
			}
		}

		return state;
	}

	render () {
		const { job, updateModel } = this.props;
		const { items } = this.state;

		if (!job) { return null; }

		const paymentGroups:JSX.Element[] = [];

		paymentGroups.push(<PaymentGroup key="unnapplied" label="Pre-Payments" payments={ job.payments } updateModel={ updateModel } />);

		_.forEach(items, item => {
			paymentGroups.push(<PaymentGroup key={ item.contract.key } label={ item.label } contract={ item.contract } payments={ job.payments } updateModel={ updateModel } />);
		});

		return (
			<div className="content jobDetail jobPayments scrollable">{ paymentGroups }</div>);
	}
}